import store from "../controller/baseController";

export default {
  AuthorizeModels(routerName) {
    if (
      routerName !== "logout" &&
      routerName !== "from_register" &&
      routerName !== "register" &&
      routerName !== "sme_register" &&
      routerName !== "accountingfirm_register" &&
      routerName !== "selectUserType" &&
      routerName !== "forgotPwd" &&
      routerName !== "resetPwd" &&
      routerName !== "sessionExpire" &&
      routerName !== "canNotAccessMerchant" &&
      routerName !== "update" &&
      routerName !== "acceptInvitation" &&
      routerName !== "selectApplication" &&
      routerName !== "registerV2" &&
      routerName !== "entrepreneur_register" &&
      routerName !== "accountant_register" &&
      routerName !== "register_partner" &&
      routerName !== "entrepreneur_register_partner" &&
      routerName !== "accountant_register_partner" &&
      routerName !== "trial_function_salesdocuments" &&
      routerName !== "trial_function_payroll" &&
      routerName !== "trial_function_tax" &&
      routerName !== "trial-function-accounting-payroll"
    ) {
      if (routerName == "login") {
        store.dispatch("DoGetRefreshTokenExpiration");
      } else {
        store.dispatch("authorizeModels");
      }
    }
  },
  SetSessionEMIFromURL(emi) {
    let getSession = sessionStorage.getItem("userMerchant");
    getSession = JSON.parse(getSession);
    if (!getSession) {
      getSession = {
        eui: "",
        emi: emi,
      };
    } else {
      getSession.emi = emi ? emi : "";
    }
    sessionStorage.setItem("userMerchant", JSON.stringify(getSession));
  },
  SetLastUrl(to) {
    if (
      to.name !== "logout" &&
      to.name !== "login" &&
      to.name !== "pageNotFound" &&
      to.name !== "createOrganization" &&
      to.name !== "createOrganizationDemo" &&
      to.name !== "from_register" &&
      to.name !== "sme_register" &&
      to.name !== "accountingfirm_register" &&
      to.name !== "selectUserType" &&
      to.name !== "forgotPwd" &&
      to.name !== "resetPwd" &&
      to.name !== "update" &&
      to.name !== "acceptInvitation" &&
      to.name !== "selectApplication" &&
      to.name !== "sessionExpire" &&
      to.name !== "welcome" &&
      to.name !== "canNotAccessMerchant" &&
      to.name !== "register" &&
      to.name !== "entrepreneur_register" &&
      to.name !== "accountant_register" &&
      to.name !== "register_partner" &&
      to.name !== "accountant_register_partner" &&
      to.name !== "entrepreneur_register_partner" &&
      to.name !== "trial_function_salesdocuments" &&
      to.name !== "trial_function_payroll" &&
      to.name !== "trial_function_tax" &&
      to.name !== "trial-function-accounting-payroll"
    ) {
      let queryStr = "";
      for (const [key, value] of Object.entries(to.query)) {
        if (value) {
          queryStr += `${key}=${value}&`;
        }
      }
      localStorage.setItem(
        "lastUrlPeakAccount",
        `${window.location.origin}${to.path}${queryStr ? "?" + queryStr : ""}`
      );
    }
  },
  DeleteLastUrl() {
    localStorage.removeItem("lastUrlPeakAccount");
  },
  GetLastUrl() {
    return localStorage.getItem("lastUrlPeakAccount");
  },
};
